import React from "react"
import { useLocation } from "react-router"
import styles from "./Footer.module.scss"
import Clock from "components/Clock/Clock"

import { Medadom } from "components/Logo/Medadom"
import { HOME_PAGE } from "core/constants"

const Footer: React.FC = () => {
  const { pathname } = useLocation()
  const isHome = [HOME_PAGE, "/"].includes(pathname)

  return (
    <div className={`${styles.Footer} ${isHome ? styles.HomeFooter : ""}`} data-testid="Footer">
      <a href="/">
        <Medadom />
      </a>
      {!isHome && (
        <span className={styles.Clock}>
          <Clock />
        </span>
      )}
    </div>
  )
}
export default Footer
